// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__aK0lK","description":"PatientConsentPreview_description__ffxbC"};